module.exports = __webpack_public_path__ + "img/ic_head_notificacoes.4cdc9943.svg";